import { motion } from 'framer-motion';
import type { ClaimPhase } from '../types';
import { getPhaseColors, type ClaimTheme } from '../constants';

interface CanvasBackgroundProps {
  phase: ClaimPhase;
  theme?: ClaimTheme;
}

export function CanvasBackground({ phase, theme = 'invol' }: CanvasBackgroundProps) {
  const colors = getPhaseColors(theme, phase);

  return (
    <motion.div
      className="absolute inset-0 -z-10"
      initial={false}
      animate={{
        background: `linear-gradient(135deg, var(--tw-gradient-from), var(--tw-gradient-to))`,
      }}
      transition={{ duration: 0.8, ease: 'easeInOut' }}
    >
      {/* Base gradient */}
      <div
        className={`absolute inset-0 bg-gradient-to-br ${colors.gradient} transition-all duration-700`}
      />

      {/* Dot pattern overlay */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `radial-gradient(circle, currentColor 1px, transparent 1px)`,
          backgroundSize: '24px 24px',
        }}
      />

      {/* Subtle radial glow */}
      <div className="absolute inset-0 bg-radial-gradient pointer-events-none" />

      {/* Top edge fade */}
      <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-white/50 to-transparent" />
    </motion.div>
  );
}
